import { PropsWithChildren } from "react";
import { HStack, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Text, UseDisclosureReturn } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { WfModalCloseButton } from "src/components/base/wf-modal-close-button";
import { ITraderAvatarUser, TraderAvatar } from "src/components/common/trader-avatar";
import { WriteCommentModalOpener } from "src/components/modals/write-comment-modal/write-comment-modal-opener";
import { useGetUserName } from "src/hooks/use-get-user-name";

export interface IWriteCommentModalSaveParams {
    content: string;
    underlyingIsin?: string;
    wikifolioId?: string;
    articlePreviewUrl?: string;
}

export interface IWriteCommentModalProps extends PropsWithChildren {
    trader: ITraderAvatarUser;
    modalProps: UseDisclosureReturn;
    onClose?: () => void;
}

export const WriteCommentModal = ({ trader, modalProps, onClose, children }: IWriteCommentModalProps) => {
    const { t } = useTranslation(["comment"]);
    const getUserName = useGetUserName();
    const topSpace = [2, 4];

    return (
        <>
            <WriteCommentModalOpener trader={trader} placeholder={t("comment-modal-opener")} onClick={modalProps.onOpen} />
            <Modal {...modalProps} onClose={onClose ?? modalProps.onClose} scrollBehavior="inside" closeOnOverlayClick={false}>
                <ModalOverlay />
                <ModalContent maxW={["full", "688px", "708px", "708px"]}>
                    <ModalHeader pt={topSpace} pb={2}>
                        <HStack alignItems="center">
                            <TraderAvatar size="md" trader={trader} />
                            <Text fontWeight="normal" fontSize="sm">
                                {getUserName(trader)}
                            </Text>
                        </HStack>
                    </ModalHeader>
                    <WfModalCloseButton top={topSpace} />
                    <ModalBody display="flex" alignItems="stretch">
                        {children}
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
};
